import React from "react"

interface Props {
    handleOpenQuotationModal: any,
    isAsoleacionModalOpened: boolean
    isQuotationModalOpened: boolean
}

interface State {}

class QuotationBtn extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {

        }
    }

    render(): React.ReactNode {
        return(
            <div 
                className={this.props.isAsoleacionModalOpened || this.props.isQuotationModalOpened ? "quotation-btn-container fade-out":"quotation-btn-container fade-im"}
                onClick = {() => {this.props.handleOpenQuotationModal()}}
            >
                Cotiza
            </div>
        )
    }
}

export default QuotationBtn